import { HttpResponseError, HttpParseError, HttpAbortError } from "@next-core/http";
import { isObject } from "@next-core/utils/general";
import { getAuth } from "../auth.js";
import { pushApiMetric } from "./analytics.js";
const symbolHttpAnalytics = Symbol("HttpAnalytics");
export function onRequest(config) {
  const perfStartTime = Math.round(performance.now());
  const st = Date.now();
  config[symbolHttpAnalytics] = {
    st,
    time: Math.round(st / 1000),
    perfStartTime
  };
  return config;
}
export function onResponse(response, config) {
  return onResponseOrError(false, response, config);
}
export function onResponseError(error, config) {
  return onResponseOrError(true, error, config);
}
function onResponseOrError(hasError, responseOrError, config) {
  const perfEndTime = Math.round(performance.now());
  const et = Date.now();
  const {
    [symbolHttpAnalytics]: meta,
    url
  } = config;
  if (meta && !(hasError && responseOrError instanceof HttpAbortError)) {
    delete config[symbolHttpAnalytics];
    const {
      st,
      time,
      perfStartTime
    } = meta;
    const {
      userInstanceId: uid,
      username
    } = getAuth();
    let code;
    let message;
    let traceId;
    let size;
    let status;
    let headers;
    let data;
    if (hasError) {
      const isHttpResponseError = responseOrError instanceof HttpResponseError;
      if (isHttpResponseError || responseOrError instanceof HttpParseError) {
        ({
          status,
          headers
        } = responseOrError.response);
        if (isHttpResponseError) {
          data = responseOrError.responseJson;
        }
      }
    } else {
      ({
        status,
        data,
        headers
      } = responseOrError);
    }
    if (isObject(data)) {
      ({
        code,
        message
      } = data);
    }
    if (headers instanceof Headers) {
      traceId = headers.get("x-b3-traceid");
      size = headers.get("content-length");
    }
    pushApiMetric({
      st,
      _ver: st,
      uid,
      username,
      time,
      et,
      page: location.href,
      duration: perfEndTime - perfStartTime,
      api: url,
      type: "api",
      code: code !== null && code !== void 0 ? code : -1,
      msg: message !== null && message !== void 0 ? message : "",
      status,
      traceId: traceId !== null && traceId !== void 0 ? traceId : "",
      size: size ? Number(size) : -1
    });
  }
  return hasError ? Promise.reject(responseOrError) : responseOrError;
}
//# sourceMappingURL=http.js.map